import React from "react";
import { Navigate } from "react-router-dom";
import RegistrosRevisionRapidaSalud from "./RegistrosPlaceholder";
import {
  canAccessRevisionRapidaSalud,
  getStoredRevisionUser,
} from "./revisionRapidaSaludUtils";

const RevisionRapidaSaludRouteGuard = ({ children }) =>
  canAccessRevisionRapidaSalud(getStoredRevisionUser()) ? children : <Navigate to="/accessDenied" replace />;

const RevisionRapidaSalud = () => <RegistrosRevisionRapidaSalud unified />;

export { RevisionRapidaSaludRouteGuard };
export default RevisionRapidaSalud;
